import gamedevBg from "../../../assests/our_services_assets/game_development.jpg";
import amazoniaBg from "../../../assests/our_services_assets/GameDevlopment.jpg";
import mobileBg from "../../../assests/our_services_assets/mobile_app.jpg";
import Platformdevelopment from "../../../assests/our_services_assets/PlatfromDevelopment.jpg";
import operatorBg from "../../../assests/our_services_assets/operator_integration.jpg";
import qaBg from "../../../assests/our_services_assets/qa.jpg";
import Regulatory from "../../../assests/our_services_assets/RegulatoryCompliance.jpg";
import analyticsBg from "../../../assests/our_services_assets/Ai.jpg";
import itBg from "../../../assests/our_services_assets/it_devops.jpg";
import gameDevIcon from "../../../assests/our_services_assets/Game_dev.png";
import gameArtIcon from "../../../assests/our_services_assets/game_art.png";
import rgsIcon from "../../../assests/our_services_assets/rgs.png";
import operatorIcon from "../../../assests/our_services_assets/operator_integration.png";
import qaIcon from "../../../assests/our_services_assets/QA.png";
import biIcon from "../../../assests/our_services_assets/Bi_Analysis.png";
import itIcon from "../../../assests/our_services_assets/IT-Dev-support.png";
import sportsbookIcon from "../../../assests/our_services_assets/sportsbook.png";

export interface Bullet {
  label?: string;
  text: string;
}

export interface Offering {
  id: number;
  title: string;
  tabLines?: string[];
  description: string;
  bullets: Bullet[];
  bg: string;
  icon: string;
  // When true, the detail panel scrolls if its content exceeds the panel
  // height; other panels never show a scrollbar. Only the content-heavy
  // "Game Art & Creative" offering overflows today.
  scrollable?: boolean;
}

export const OFFERINGS: Offering[] = [
  {
    id: 1,
    title: "Game Development",
    description:
      "Dedicated game dev studios plus AI assisted accelerators save 20%+ effort across concept, prototyping and development.",
    bullets: [
      { text: "Gen AI concepting turns a theme or keyword into a full slot concept (story, math model, and symbol art) in hours" },
      { text: "Slot, table, instant win, and crash/skill titles built on certified, provably fair logic" },
      { text: "Reusable, configuration driven game framework and presets" },
      { text: "End-to-end game math: PAR sheet engineering, simulation, and math engine implementation" },
      { text: "HTML5 cross-platform development using Pixi.js, optimized for web and mobile browsers" },
    ],
    bg: gamedevBg,
    icon: gameDevIcon,
  },
  {
    id: 2,
    title: "Game Art & Creative",
    description:
      "Original art, animation, and UX that turn game mechanics into worlds players return to.",
    bullets: [
      { label: "Concept Art", text: "Turn game visions into compelling concepts and style guides that define, validate, and guide artistic direction." },
      { label: "2D Art", text: "Premium, game-ready 2D characters, symbols, environments, props, and UI/UX assets that boost engagement and strengthen brand identity." },
      { label: "3D Art", text: "High-quality, game-ready 3D characters, weapons, props, and environments, optimized for real-time and pre-rendered use." },
      { label: "Animation & VFX", text: "Optimized animations and VFX that bring characters, symbols, props, UI, and feature sequences to life." },
      
    ],
    bg: amazoniaBg,
    icon: gameArtIcon,
    scrollable: true,
  },
  {
    id: 3,
    title: "Mobile App Development",
    description:
      "Native and wrapper apps that launch into new jurisdictions fast and compliantly ",
    bullets: [
      { text: "iOS and Android (native, React Native, Flutter) optimized for speed and battery" },
      { text: "App Store / Play Store compliance navigation for real money gaming in regulated markets" },
      { text: "Push, geolocation, and biometric/secure login features supporting engagement and KYC" },
      { text: "Lightweight, network aware builds for varied device conditions" },
      { text: "Wrapper app framework with age gating, geo controls, and responsible gambling compliance for 50–70% faster market launches" },
    ],
    bg: mobileBg,
    icon: sportsbookIcon,
  },
  {
    id: 4,
    title: "Platform Development",
    description:
      "Cloud-native iGaming platforms built and modernized on a microservices core ",
    bullets: [
      { text: "Player Account Management (PAM), wallet, bonus, and CRM modules on cloud native architecture" },
      { text: "Microservices and API-first design for easy content, payment, and third party onboarding" },
      { text: "High availability infrastructure built for traffic spikes around major sporting and jackpot events" },
      { text: "Legacy platform modernization and incremental migration with minimal downtime" },
      { text: "AI-assisted, spec-based RGS, RNG, and SDK engineering" },
    ],
    bg: Platformdevelopment,
    icon: rgsIcon,
  },
  {
    id: 5,
    title: "B2B Integration",
    description:
      "Proven, repeatable integration of games and content into operator and aggregator platforms ",
    bullets: [
      { text: "250+ B2B integrations delivered, with a baseline framework that halves onboarding time" },
      { text: "Standardized APIs and rapid onboarding to shorten go live cycles across operators" },
      { text: "AI assisted integration mapping accelerates kick-off and reduces manual effort" },
    ],
    bg: operatorBg,
    icon: operatorIcon,
  },
  {
    id: 6,
    title: "QA & Test Automation",
    description:
      "AI driven quality engineering that cuts manual effort while protecting fairness and scale: shift-left, with phased quality gates and measurable KPIs ",
    bullets: [
      { text: "Functional, math/RTP, and regression testing for games and platform features" },
      { text: "Automated test suites and CI/CD pipelines for faster, safer releases" },
      { text: "Performance and load testing for high-concurrency, real money scenarios" },
      { text: "Compliance readiness testing aligned to target jurisdictions" },
      { text: "Security testing aligned with OWASP Top 10, SAST/DAST in CI/CD, VAPT assessments, and penetration testing for certification readiness" },
    ],
    bg: qaBg,
    icon: qaIcon,
  },
  {
    id: 7,
    title: "Regulatory Compliance & Reporting",
    description:
      "Real time reporting pipelines and certification support that enable faster go live in new markets ",
    bullets: [
      { text: "Reusable reporting frameworks for real-time, batch, and on-demand submissions cut time to market for new jurisdictions" },
      { text: "Regulator ready outputs in XML, CSV, XLSX, and PDF accelerate approvals and reduce manual effort" },
      { text: "Secure delivery via API, email, SFTP/vault, and replica DB improves audit readiness and regulator trust" },
      { text: "Multi jurisdiction coverage across language, currency, time zone, and core compliance data supports scalable market expansion" },
    ],
    bg: Regulatory,
    icon: biIcon,
  },
  {
    id: 8,
    title: "AI & Personalization",
    description:
      "Turn player and operator friction into flow with connected AI, built on Nagarro's Fluidic Intelligence framework ",
    bullets: [
      { text: "AI driven game discovery, player journey orchestration, and promotion optimization across touchpoints" },
      { text: "Segmentation, VIP identification, churn prediction, and targeted lifecycle interventions" },
      { text: "Copilot enabled workflows for support, KAM, and operations teams to improve resolution speed and decision quality" },
      { text: "Proactive monitoring, anomaly detection, and intervention frameworks across player and transaction flows" },
    ],
    bg: analyticsBg,
    icon: biIcon,
  },
  {
    id: 9,
    title: "24×7 Managed Services",
    description:
      "Round the clock operations, monitoring, and support that keep games and platforms live and performing. ",
    bullets: [
      { text: "24x7 monitoring, incident response, and SLA backed coverage" },
      { text: "L1–L3 support, live ops, and release management" },
      { text: "Proactive performance, capacity, and cost optimization" },
      { text: "Continuous maintenance, patching, and security hardening" },
    ],
    bg: itBg,
    icon: itIcon,
  },
];
